export enum BinNetsuiteSyncStatusEnum {
  UPDATING = 'updating',
  COMPLETED = 'completed',
  UPDATE_FAILED = 'update-failed',
}
